import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import RequestSummary from '../SubComponents/RequestSummary';
import {
  SESSION_STORAGE_SCHEDULE_APPOINTMENT_KEY,
  SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY,
  ACTIVITY_OBJECT_KEY, SPWL_SCHEDULE_APPOINTMENT_KEY,
  ADVISOR_CASES_STATUS_HIGH_LEVEL_KEY,
  ADVISOR_ACTIVITY_CENTER_KEY,
  ADVISOR_ACTIVITY_CENTER_SUMMARY_DETAILS_KEY,
  ILLUSTRATION_PREFILL_DATA,
  SESSION_STORAGE_CREATE_CASE,
  SESSION_STORAGE_CLIENT_ACCOUNT_INFO
} from '../../../../sessionStorage';
import VerticalStepper from '../../../Common/VerticalStepper';
import { makeStyles } from "@material-ui/core/styles";
import ApplicationReview from '../../../../icons/applicationReview.svg';
import SupervisoryReview from '../../../../icons/SupervisoryReview.svg';
import InsuranceCompany from '../../../../icons/insuranceCompany.svg';
import PolicyIssuance from '../../../../icons/policyIssuance.svg';

const useStyles = makeStyles(theme => ({
  link: {
    color: `${theme.palette.primary.main} !important`,
    cursor: 'pointer'
  },
}))

export default function SubmitCase(props) {
  const isSubmitCase = props.isSubmitCase || false;
  let productInfo;
  const insuredInfo = props.basicInfo && props.basicInfo.pages.insuredBasicInfo ? props.basicInfo.pages.insuredBasicInfo : '';
  const clientInfo = props.basicInfo && props.basicInfo.pages.clientType ? props.basicInfo.pages.clientType : '';
  const requestSummary = props.basicInfo && props.basicInfo.pages.requestSummary ? props.basicInfo.pages.requestSummary : '';
  let agentInfo;
  if (props.isNewCaseRequest) {
    const product = props.basicInfo && props.basicInfo.pages.quoteDetail ? props.basicInfo.pages.quoteDetail : '';
    const productAmount = props.basicInfo && props.basicInfo.pages.proposedInsurance ? props.basicInfo.pages.proposedInsurance : '';
    productInfo = {
      healthClass: '',
      product: product.product,
      carrierName: product.carrier,
      term: product.term || product.GuaranteedDeathBenefit,
      coverageAmount: product.premiumPaid || product.premiumAmount,
      premium: '',
      annualPremium: productAmount.annualPremium,
      carrierID: '',
    };
    agentInfo = props.basicInfo && props.basicInfo.pages.selectAgent ? props.basicInfo.pages.selectAgent : '';
  } else {
    // Term Life
    productInfo = props.product ? props.product : '';
    agentInfo = props.agentInfo;
  }
  const classes = useStyles();

  useEffect(() => {
    return () => {
      if (props.isTermSession) {
        sessionStorage.removeItem(SESSION_STORAGE_SCHEDULE_APPOINTMENT_KEY);
        sessionStorage.removeItem(SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY);
      } else if (props.isNewCaseRequestSession) {
        sessionStorage.removeItem(ACTIVITY_OBJECT_KEY);
        sessionStorage.removeItem(SESSION_STORAGE_CREATE_CASE);
      } else if (props.isSPWLSession) {
        sessionStorage.removeItem(SPWL_SCHEDULE_APPOINTMENT_KEY);
      }
      sessionStorage.removeItem(ADVISOR_CASES_STATUS_HIGH_LEVEL_KEY);
      sessionStorage.removeItem(ADVISOR_ACTIVITY_CENTER_KEY);
      sessionStorage.removeItem(ADVISOR_ACTIVITY_CENTER_SUMMARY_DETAILS_KEY);
      sessionStorage.removeItem(SESSION_STORAGE_CLIENT_ACCOUNT_INFO);
    };
  }, []);

  const steps = [
    {
      label: 'The application team will review the packet for completeness',
    },
    {
      label: 'The application will be sent for supervisory review',
    },
    {
      label: 'Upon supervisory approval, application will be submitted to the insurance company for underwriting and final pricing determination.',
    },
    {
      label: 'Policy issuance and delivery typically takes 6-8 weeks.',
    },
  ];

  const stepIcons = {
    1: <ApplicationReview />,
    2: <SupervisoryReview />,
    3: <InsuranceCompany />,
    4: <PolicyIssuance />,
  };
  return (
    <div className='pt-3'>
      <Row className={`${props.isSPWL ? '' : 'border-class'}`}>
        <RequestSummary
          isSPWL={props.isSPWL || false}
          finalSummary={props.finalSummary}
          productInfo={productInfo}
          insuredInfo={insuredInfo}
          clientInfo={clientInfo}
          agentInfo={agentInfo}
          requestSummary={requestSummary}
          data={props}
          isSubmitCase={isSubmitCase}
        />
        <Col md={6} className="pt-4 px-0">
          <h4 className="mt-5 pt-2">
            <b>Your client's application request has been submitted. What happens next:</b>
          </h4>
          <VerticalStepper stepIcons={stepIcons} steps={steps} />
          <span><b>Application status can be viewed in the</b> <a onClick={() => props.history.push(`/ActivityCenter/${2}/${props.caseID}`)} className={classes.link}>ACTIVITY CENTER</a></span>
        </Col>
      </Row>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/SubComponents/SubmitCase.js